// extracted by mini-css-extract-plugin
module.exports = {"container":"ga-z"};